import { UpdateExternalContactRequestSchema, UpdateExternalContactResponseSchema } from './update-external-contact.schema';
/**
 * Update External Contact Endpoint Contract
 * Updates an existing external contact by ID
 */ export const updateExternalContactContract = {
    method: 'PATCH',
    path: '/api/v2/external-contact/:id',
    description: 'Update an existing external contact by ID',
    requestSchema: UpdateExternalContactRequestSchema,
    responseSchema: UpdateExternalContactResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - invalid input data',
            401: 'Unauthorized - user not authenticated',
            404: 'External contact not found'
        }
    }
};

//# sourceMappingURL=update-external-contact.contract.js.map